import React, { useEffect, useState } from "react";
import "./styling/App.css";
import {
  BrowserRouter as Router,
  Route,
  Routes,
  Link,
  useLocation,
  useNavigate,
  useSearchParams,
} from "react-router-dom";
import LoginButton from "./components/LoginButton";
import StartPage from "./components/StartPage";
import EventSignup from "./components/EventSignup";
import { verifyMagicLink } from "./api";

const JWT_KEY = "magic-link-jwt";
const AUTH_CHANGED_EVENT = "auth-changed";

const HomeButton: React.FC = () => {
  const { pathname } = useLocation();
  const [isLoggedIn, setIsLoggedIn] = useState(() =>
    Boolean(localStorage.getItem(JWT_KEY)),
  );

  useEffect(() => {
    const updateLogin = () => setIsLoggedIn(Boolean(localStorage.getItem(JWT_KEY)));
    const handleStorage = (e: StorageEvent) => {
      if (e.key === JWT_KEY) setIsLoggedIn(Boolean(e.newValue));
    };
    window.addEventListener(AUTH_CHANGED_EVENT, updateLogin);
    window.addEventListener("storage", handleStorage);
    return () => {
      window.removeEventListener(AUTH_CHANGED_EVENT, updateLogin);
      window.removeEventListener("storage", handleStorage);
    };
  }, []);

  if (!isLoggedIn || pathname === "/home") return null;

  return (
    <div className="home-corner">
      <Link to="/home" className="home-btn">Startsida</Link>
    </div>
  );
};

const VerifyPage: React.FC = () => {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const token = searchParams.get("token");

  useEffect(() => {
    if (!token) {
      navigate("/");
      return;
    }

    // Remove the token from the URL as early as possible.
    window.history.replaceState({}, document.title, "/verify");

    verifyMagicLink(token)
      .then((jwt) => {
        localStorage.setItem(JWT_KEY, jwt);
        window.dispatchEvent(new Event(AUTH_CHANGED_EVENT));
        window.close();
        navigate("/");
      })
      .catch(() => navigate("/"));
  }, [token, navigate]);

  return <p style={{ textAlign: "center", marginTop: "2rem" }}>Loggar in...</p>;
};

const isLoggedInMode = new URLSearchParams(window.location.search).get("loggedinmode") === "true";

const App: React.FC = () => {
  return (
    <Router>
      <div className="App">
        <HomeButton />
        {isLoggedInMode && (
          <div className="login-corner">
            <LoginButton />
          </div>
        )}
        <Routes>
          <Route path="/" element={<EventSignup />} />
          <Route path="/home" element={<StartPage />} />
          <Route path="/verify" element={<VerifyPage />} />
        </Routes>
      </div>
    </Router>
  );
};

export default App;
